import { Download, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

export const AuditTab = ({ audit }) => (
  <div className="flex min-h-0 flex-1 flex-col" data-testid="ask-aria-audit-panel">
    <div className="flex items-center gap-2 border-b border-[#1e1e1e] px-4 py-2.5">
      <span className="text-[11.5px] text-[#6b6b6b]">
        {audit === null ? "Loading history…" : `${audit.length} entries — everything Aria has done, and when`}
      </span>
      <button onClick={() => window.open(`${api.defaults.baseURL}/aria/audit/export`, "_blank")}
        data-testid="aria-audit-export"
        className="ml-auto flex h-7 items-center gap-1.5 rounded-md bg-[rgba(79,142,247,0.14)] px-2.5 text-[11.5px] font-medium text-[#7FAEF9] transition-colors hover:bg-[rgba(79,142,247,0.28)] hover:text-white">
        <Download size={11} /> Export CSV
      </button>
    </div>
    <div className="flex-1 space-y-1.5 overflow-y-auto p-3">
      {audit !== null && audit.length === 0 && (
        <div className="px-4 py-10 text-center text-[11.5px] text-[#6b6b6b]">
          No history yet — every query, action and task Aria runs will be logged here.
        </div>
      )}
      {(audit || []).map((it, i) => (
        <div key={i} className="rounded-xl bg-[#141414] p-3" data-testid={`aria-audit-row-${i}`}>
          <div className="flex items-center gap-2">
            <span className={`rounded-md px-1.5 py-[1px] text-[9px] font-semibold uppercase tracking-wide ${
              it.type === "action" ? "bg-[rgba(34,197,94,0.16)] text-[#4ADE80]"
              : it.type === "task" ? "bg-[rgba(245,158,11,0.15)] text-[#FBBF24]"
              : "bg-[rgba(79,142,247,0.14)] text-[#7FAEF9]"}`}>
              {it.type}
            </span>
            {it.context && <span className="text-[9.5px] text-[#555]">on {it.context}</span>}
            <span className="ml-auto text-[9.5px] tabular-nums text-[#555]">
              {it.ts ? new Date(it.ts).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : ""}
            </span>
          </div>
          <div className="mt-1.5 text-[12px] font-medium text-white">{it.text}</div>
          {it.detail && <div className="mt-0.5 line-clamp-2 text-[10.5px] leading-relaxed text-[#A3A3A3]">{it.detail}</div>}
          {it.navigation && (
            <div className="mt-1 flex items-center gap-1 text-[10px] text-[#7FAEF9]">
              <ArrowUpRight size={10} /> navigated to {it.navigation}
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
);
